import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ASSETS_BASE_URL } from "../../config";

const DocCardImage = ({ 
    type, 
    filename, 
    path, 
    url,
    fileExtension
}) => {
    const resolvedType = useMemo(() => {
        const result = inferType({ 
            type, 
            filename, 
            path, 
            url, 
            fileExtension
        });
        return result;
    }, [type, filename, path, url, fileExtension]);
    
    const [imgSrc, setImgSrc] = useState(() => {
        const icon = getIconForType(resolvedType);
        return icon;
    });
    const { t } = useTranslation();
    function inferType({ type, filename, path, url, fileExtension }) {
        
        if (fileExtension && typeof fileExtension === 'string') {
            return `ext:${fileExtension.toLowerCase()}`;
        }
        
        if (type && typeof type === 'string' && type.includes('/')) {
            return type.toLowerCase();
        }
        
        const src = path || filename || url || '';
        
        try {
            const parsed = new URL(src, 'http://dummy');
            const pathname = parsed.pathname || '';
            const ext = pathname.split('.').pop()?.toLowerCase();
            if (ext && ext.length > 0 && ext.length < 10) {
                return `ext:${ext}`;
            }
        } catch (e) {
        }
        
        const s = String(src);
        if (s.includes('.')) {
            const ext = s.split('.').pop()?.toLowerCase();
            if (ext && ext.length > 0 && ext.length < 10) {
                return `ext:${ext}`;
            }
        }

        return 'default';
    }

    function getIconForType(t) {
        switch (t) {
            case "application/pdf":
            case "ext:pdf":
                return `${ASSETS_BASE_URL}/icons/pdf.png`;

            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            case "application/vnd.ms-excel":
            case "ext:xls":
            case "ext:xlsx":
                return `${ASSETS_BASE_URL}/icons/xls.png`;

            case "application/msword":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            case "ext:doc":
            case "ext:docx":
                return `${ASSETS_BASE_URL}/icons/doc.png`;

            case "image/jpeg":
            case "image/jpg":
            case "ext:jpeg":
            case "ext:jpg":
                return `${ASSETS_BASE_URL}/icons/jpg.png`;

            case "application/zip":
            case "application/x-7z-compressed":
            case "application/vnd.rar":
            case "ext:zip":
            case "ext:7z":
            case "ext:rar":
                return `${ASSETS_BASE_URL}/icons/zip.png`;

            case "image/png":
            case "ext:png":
                return `${ASSETS_BASE_URL}/icons/png.png`;

            case "image/webp":
            case "ext:webp":
            case "ext:gif":
            case "ext:bmp":
                return `${ASSETS_BASE_URL}/icons/img.png`;

            case "text/csv":
            case "ext:csv":
                return `${ASSETS_BASE_URL}/icons/csv.png`;

            case "application/vnd.ms-powerpoint":
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            case "ext:ppt":
            case "ext:pptx":
                return `${ASSETS_BASE_URL}/icons/ppt.png`;

            case "ext:dwg":
            case "ext:dxf":
                return `${ASSETS_BASE_URL}/icons/dwg.png`;

            case "ext:stp":
            case "ext:step":
            case "ext:iges":
            case "ext:igs":
                return `${ASSETS_BASE_URL}/icons/cad.png`;

            case "ext:stl":
                return `${ASSETS_BASE_URL}/icons/3d.png`;

            case "video/mp4":
            case "video/quicktime":
            case "video/x-msvideo":
            case "video/x-matroska":
            case "video/webm":
            case "video/avi":
            case "ext:mp4":
            case "ext:mov":
            case "ext:avi":
            case "ext:mkv":
            case "ext:webm":
            case "ext:wmv":
            case "ext:flv":
            case "ext:mov":
            case "ext:m4v":
            case "ext:3gp":
            case "ext:mpg":
            case "ext:mpeg":
                return `${ASSETS_BASE_URL}/icons/vdo.png`;

            default:
                return `${ASSETS_BASE_URL}/icons/default.png`;
        }
    }

    const handleError = () => {
        setImgSrc(`${ASSETS_BASE_URL}/icons/default.png`);
    };

  return <img width="30" height="30" src={imgSrc} alt={t('GENERAL.DOC_ICON')} onError={handleError} />;
};

export default DocCardImage;
